import React, { useState, useEffect } from 'react';
import API from '../library/ApiManager'
import Fnc from '../library/Functions'
import InlineFieldLoader from './InlineFieldLoader';

function PivaInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [pivaVerified, setPivaVerified] = useState(false);

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
    if (props.isLogged && props.iva != null && props.iva.length > 0 && props.loadData) {
      //ho una partita iva valida e sono loggato. Devo caricare i contenuti del customer da Salesforce, non prendo quelli di SSO. 
      // Una volta caricati verranno rimandati con una callback al modulo fatturazione che provvederà ad aggiornare tutti gli altri campi.
      Fnc.log("=== CUSTOMER CALL", props, Fnc.LogLvl.INFO);
      checkPiva(props.iva);
    }

  }, [props.isLogged, props.iva, props.loadData]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;
    checkPiva(val);
  }

  function checkPiva(val) {

    //if (props.required) {
    //è un campo obbligatorio?

    if (val && val.length > 0) {
      //non ho un valore vuoto

      if (pivaVerified !== val) {
        //non è un valore che ho già controllato

        setPivaVerified(null); //resetto eventuali salvataggi precedenti

        let valdPiva = Fnc.validatePiva(val);
        if (valdPiva === Fnc.EnmPiva.OK) {
          //piva formalmente valida?

          setLoading(true);

          //-----
          API.getCustomer(val, (data) => {
            if (data && data != null) {
              setPivaVerified(val);
              if (props.isLogged) {
                //UTENTE LOGGATO : controllo che il codice della response sia OK
                if (data && data.response && (data.response.code === 'OK')) {
                  setShowError(false);
                  setErrorMsg(null);
                  props.callback(new Fnc.Ret(Fnc.EnmPiva.OK, data));
                } else {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmPiva.KO.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmPiva.KO));
                }
              } else {
                //UTENTE NON LOGGATO : controllo tutte le condizioni
                if (data && data.response && data.response.code === 'OK') {
                  if (data.invoicingData && (data.invoicingData.alreadyKnown || data.invoicingData.commission)) {
                    //piva di un già cliente
                    setShowError(true);
                    setErrorMsg(Fnc.EnmPiva.NOTFREE.msg);
                    props.callback(new Fnc.Ret(Fnc.EnmPiva.NOTFREE));
                  } else {
                    setShowError(false);
                    setErrorMsg(null);
                    props.callback(new Fnc.Ret(Fnc.EnmPiva.OK, data));
                  }
                } else if (data && data.response && data.response.code === 'NOT_FOUND') {
                  //piva valida ma non trovata nei database SALESFORCE. N.B. Passo la piva invece che tutto l'oggetto customer
                  setShowError(false);
                  setErrorMsg(null);
                  props.callback(new Fnc.Ret(Fnc.EnmPiva.NOT_FOUND, val));
                } else {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmPiva.KO.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmPiva.KO));
                }
              }
            } else {
              //CHIMATA KO : qualcosa è andato storto nella chiamata rest
              setPivaVerified(null);
              setShowError(true);
              setErrorMsg(Fnc.EnmPiva.SERVER_DOWN.msg);
              props.callback(new Fnc.Ret(Fnc.EnmPiva.SERVER_DOWN));
            }
            setLoading(false);

          });

        } else {
          //la piva specificata è formalmente non valida
          setPivaVerified(null);
          setShowError(true);
          setErrorMsg(valdPiva.msg);
          props.callback(new Fnc.Ret(valdPiva));
        }

      }

    } else {
      if (props.required) {
        setShowError(true);
        setErrorMsg(Fnc.EnmPiva.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmPiva.EMPTY));
        setPivaVerified(null); //resetto eventuali salvataggi precedenti
      }
    }

    //} else {
    //  setShowError(false);
    //  setErrorMsg(null);
    //  props.callback(new Fnc.Ret(Fnc.EnmPiva.OK, null));
    //}

  }


  return (
    <>
      <input className={`form-control ${props.isLogged && "disabled"} ${showError ? "iol-field--error" : ""}`} type="text" placeholder="Es. 12345678901" disabled={props.isLogged} aria-labelledby="piva" key={props.iva} defaultValue={props.iva} onBlur={onBlur} aria-invalid={showError}></input>
      <span className={`placeholder-text ${showError && "lblError"} `}>
        {props.required && <span className="checkout-required-marker" aria-hidden="true">*</span>} Partita IVA
      </span>
      <InlineFieldLoader visible={loading} label="Verifica partita IVA in corso" />
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default PivaInp;
